var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ion-card',[_c('ion-card-header',[_c('h2',[_vm._v("Smartbox Token")])]),_c('ion-card-content',[_c('copyable-code',{attrs:{"code":_vm.token}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }